import { useTranslation } from 'react-i18next'

export function Footer() {
  const { t } = useTranslation('common')
  return (
    <footer className="border-t bg-background py-1.5 px-4 sm:px-6 lg:px-8 mt-auto">{/* #368 — one slim line */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-label text-muted-foreground">
        <p>
          {t('footer.poweredBy')} <span className="font-semibold text-foreground">{t('footer.company')}</span> © {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  )
}
